import axios from 'commons/http/axios';
import { PORTAL_SERVICOS_BACKEND } from 'commons/constants/environment';
import { getIdentificationUserStorageWithMask } from '../util/sanitizerUser';

const BASE_URL_NOTIFICACAO = `${PORTAL_SERVICOS_BACKEND}/frontend/central-notificacao`;

export default {
	getTotalNotificacaoUsuario: async () => {
		const identificadorUsuario = await getIdentificationUserStorageWithMask();
		return axios.get(`${BASE_URL_NOTIFICACAO}/usuario/${identificadorUsuario}/total`).then(res => {
			return res;
		});
	},
	getNotificacaoPaginadoUsuario: async (page, size, search = '') => {
		const identificadorUsuario = await getIdentificationUserStorageWithMask();
		return axios
			.get(
				`${BASE_URL_NOTIFICACAO}/usuario/${identificadorUsuario}/paginado?page=${page}&size=${size}&search=${search}`
			)
			.then(res => {
				return res;
			});
	},
	resetTotalNotifications: async () => {
		const identificadorUsuario = await getIdentificationUserStorageWithMask();
		return axios.put(`${BASE_URL_NOTIFICACAO}/usuario/${identificadorUsuario}/total`).then(res => {
			return res;
		});
	},

	updateStatusNotificationsById: news => {
		return axios.put(`${BASE_URL_NOTIFICACAO}/${news.cdNotificacaoBrowser}`, news).then(res => {
			return res;
		});
	},

	updateAllStatusNotifications: async () => {
		const identificadorUsuario = await getIdentificationUserStorageWithMask();
		return axios.put(`${BASE_URL_NOTIFICACAO}/usuario/${identificadorUsuario}`).then(res => {
			return res;
		});
	}
};
